import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage.jsx';
import ServicesPage from './pages/ServicesPage.jsx';
import Microsoft365Page from './pages/Microsoft365Page.jsx';
import CybersecurityPage from './pages/CybersecurityPage.jsx';
import ManagedITPage from './pages/ManagedITPage.jsx';
import PricingPage from './pages/PricingPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.jsx';
import ServiceAreaPage from './pages/ServiceAreaPage.jsx';
import ReferralsPage from './pages/ReferralsPage.jsx';
import MDMPage from './pages/MDMPage.jsx';
import ThankYouPage from './pages/ThankYouPage.jsx';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/microsoft-365" element={<Microsoft365Page />} />
          <Route path="/cybersecurity" element={<CybersecurityPage />} />
          <Route path="/managed-it" element={<ManagedITPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/service-area" element={<ServiceAreaPage />} />
          <Route path="/referrals" element={<ReferralsPage />} />
          <Route path="/mdm" element={<MDMPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;